__turbopack_context__.v({
  "container": "cnqq7W_container",
  "count": "cnqq7W_count",
  "description": "cnqq7W_description",
  "loading": "cnqq7W_loading",
  "number": "cnqq7W_number",
  "shimmer": "cnqq7W_shimmer",
});
